<template>
    <div :class="['contenedor-adjuntos', { pending: !puedeDescargar, reduced: props.reducedActions }]" v-if="fichero != null">
        <span class="file-name">{{ model.fileName }}</span>
        <div :class="['file-actions', { pending: !puedeDescargar, reduced: props.reducedActions }]">
            <span v-if="!puedeDescargar && !reducedActions" class="pendiente"><i class="fa fa-info-circle"></i>
                {{ textForNonDownloadableFiles == null ? '' : textForNonDownloadableFiles }}
            </span>
            <div>
                <DxButton v-if="!reducedActions" text="Reemplazar" @click="onReemplazarClicked" icon="fa fa-arrows-retweet"></DxButton>
                <DxButton @click="onFileRemoved" styling-mode="text" type="default" icon="fa fa-trash" :text="props.reducedActions ? '' : 'Eliminar'">
                </DxButton>
                <DxButton v-if="!reducedActions" text="Descargar" @click="onFileDownloadRequested" :visible="puedeDescargar" icon="fa fa-download">
                </DxButton>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { DxButton } from 'devextreme-vue';
import { computed, ref } from 'vue';

const props = defineProps<{
    fichero: Fichero
    supportedExtensions?: string[],
    textForAddAttachmentLabel: string,
    textForAddAttachmentButton: string,
    textForNonDownloadableFiles: string,
    reducedActions: boolean
}>();
const model = computed(() => props.fichero);
const textForNonDownloadableFiles = computed(() => props.textForNonDownloadableFiles);

const emit = defineEmits<{
    (ev: 'update:fichero', file: Fichero): void,
    (ev: 'fileReplaceRequested'): void,
    (ev: 'fileRemoveRequested'): void,
    (ev: 'fileDownloadRequested'): void
}>();


const puedeDescargar = computed(() => model.value != null && model.value.isRemote === true);

function onFileRemoved(): void {
    emit("fileRemoveRequested");
}


function onReemplazarClicked(): void {
    emit("fileReplaceRequested");
}


function onFileDownloadRequested() {
    emit("fileDownloadRequested");
}
</script>
<style scoped lang="scss">

.contenedor-adjuntos {
    display: flex;
    flex-direction: column;
    padding: var(--spacing-sm);
    justify-content: space-between;
    margin: 4px 0;
    border-radius: var(--border-radius-lg);
    box-shadow: 0px 4px 4px 0px rgba(36, 36, 36, 0.10);

    border: 1px solid var(--border-default-default);

    /*&.pending {
        border-style: dashed;
       background-color: $datagrid-row-alternation-bg;
    }*/

    &.reduced {
        flex-direction: row;
        display: flex !important;
        justify-content: flex-end;
        align-items: center;
        padding: var(--spacing-2xs) var(--spacing-xs); // Reduce el espacio
        min-width: 120px;
        max-width: 180px;
        justify-content: space-between;
        color: var(--text-default-caption);
    }
}

.file-name {
    margin-right: var(--spacing-sm);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100px;
}

.file-actions {
    display: flex;
    justify-content: end;
    align-items: center;

    .pendiente {
        font-size: 0.875em;
        font-style: italic;
        display: flex;
        gap: var(--spacing-2xs);
    }

    div {
        display: flex;
        gap: var(--spacing-xs);
    }

    &.pending {
        justify-content: space-between;
    }
}
</style>